import { Component } from '@angular/core';

@Component({
  selector: 'app-logo-showcase-redesign',
  templateUrl: './logo-showcase-redesign.component.html',
  styleUrls: ['./logo-showcase-redesign.component.scss']
})
export class LogoShowcaseRedesignComponent {

}
